module.exports = __webpack_public_path__ + "media/components/videos_internal/bluezones-1_1_percents-604ecef222cac188ae7d40a08c3e85be.jpg";